import { useCallback, useState } from "react";
import type { Glider } from "../lib/glider";
import { loadGliderDb } from "../lib/glider-db";

type Status = "idle" | "loading" | "ready" | "error";

/**
 * Lazily loads the glider database on first demand. `ensureLoaded` is
 * idempotent — call it when the picker opens or when the URL hash names an
 * unknown glider; subsequent calls are no-ops.
 */
export function useGliderDb() {
  const [gliders, setGliders] = useState<readonly Glider[] | null>(null);
  const [status, setStatus] = useState<Status>("idle");

  const ensureLoaded = useCallback(() => {
    setStatus((prev) => {
      if (prev !== "idle") return prev;
      loadGliderDb().then(
        (loaded) => {
          setGliders(loaded);
          setStatus("ready");
        },
        () => setStatus("error"),
      );
      return "loading";
    });
  }, []);

  return { gliders, status, ensureLoaded };
}
